module.exports = __webpack_public_path__ + "img/Oficina Peru.d152b30e.jpeg";